import { ElementCategory, StandardType } from "@easy-email-pro-core/constants";
import { StandardTextListElement } from "@easy-email-pro-core/typings";
import { createBlock, mergeBlock, t } from "@easy-email-pro-core/utils";
import React from "react";
import { Text } from "@easy-email-pro-core/components/Elements";
import { BasicBlock } from "@easy-email-pro-core/components";

const defaultData: StandardTextListElement = {
  type: StandardType.STANDARD_TEXT_LIST,
  data: {},
  attributes: {
    "list-style": "number",
    "padding-top": "3px",
    "padding-bottom": "3px",
    "padding-left": "2px",
    "padding-right": "2px",
    "font-size": "16px",
    "line-height": "120%",
    "font-weight": "normal",
  },
  children: [],
};

export { StandardTextListItem } from "./TextListItem";

export const StandardTextList = createBlock<StandardTextListElement>({
  get name() {
    return t("Text list");
  },
  defaultData: defaultData,
  type: StandardType.STANDARD_TEXT_LIST,
  create: (payload) => {
    return mergeBlock(
      {
        type: StandardType.STANDARD_TEXT_LIST,
        data: {},
        attributes: { "list-style": "number" },
        children: [],
      },
      payload
    );
  },
  category: ElementCategory.TEXT_LIST,
  render(params) {
    const { node } = params;

    const attributes = node.attributes;

    return (
      <Text idx={params.idx} data={node.data} {...attributes}>
        <BasicBlock
          tag={node.attributes["list-style"] === "number" ? "ol" : "ul"}
          params={{
            ...params,
            node: {
              ...params.node,
              attributes: {} as any,
            },
          }}
        />
      </Text>
    );
  },
});
